// removed by extract-text-webpack-plugin
module.exports = {"chart":"chart__223-T"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Gateway/coms/GatewayDetail/coms/GatewayPktPie/styles.scss
// module id = 2265
// module chunks = 1